<script setup lang="ts">
import $ from 'jquery';
import { computed, ref, shallowRef, unref, watch } from 'vue';

import { SideNav } from '#public_ts/components';
import { useDisplayWidths, useJqueryEventListener } from '#public_ts/composables';

import type { MenuForm, MenuPanel } from './globals';
import { __MENU_PANELS_COMPACT_MODE__ } from './globals';
import MenuSingleItem from './menu-single-item.vue';
import { useGlobalSeacrh } from './util';

const props = defineProps<{
    panel: MenuPanel;
    noAutoToggle?: boolean;
    multilineLayout?: boolean;
    sidenav?: boolean;
    sidenavTitle?: string;
}>();

const emit = defineEmits<{
    (event: 'collapse'): void;
}>();

const panel0 = computed(() => props.panel);
const ROOT = __ROOT__;
const APP_VERSION_QS = __APP_VERSION_QS__;
const { toggleMenuPanelsGlobal } = useGlobalSeacrh();
const collapsePanelRef = shallowRef<HTMLElement | undefined>();
const CHUNK_SIZE = 7;
const DISPLAY_WIDTHS = useDisplayWidths();
const sideNavOpen = ref(false);

const chunks = computed(() => {
    if(DISPLAY_WIDTHS.user <= DISPLAY_WIDTHS.xl) return undefined;
    const _chunks: MenuForm[][] = [];
    for(let i = 0; i < unref(panel0).panel.length; i += CHUNK_SIZE) {
        _chunks.push(unref(panel0).panel.slice(i, i + CHUNK_SIZE));
    }
    if(_chunks.length == 1) return undefined;
    return _chunks;
});

watch(toggleMenuPanelsGlobal, (val) => {
    if(props.noAutoToggle) return;
    $(unref(collapsePanelRef) ?? []).collapse(val ? 'show' : 'hide');
});

useJqueryEventListener(collapsePanelRef, 'shown.bs.collapse hidden.bs.collapse', () => {
    emit('collapse');
});
</script>

<template>
    <li class="bg-info" :class="panel0.name.replace(/ /g, '-').toLowerCase()">
        <a
            data-toggle="collapse"
            :href="`#${panel0.id}`"
            aria-expanded="false"
            :aria-controls="panel0.id"
            class="menu-item parent-menu-item rounded-3 nav-link dropdown-toggle"
            @click="sideNavOpen = true"
        >
            <slot name="anchor">
                {{ panel0.name }}
                <img
                    v-if="__MENU_PANELS_COMPACT_MODE__ !== 'true'"
                    width="32"
                    height="32"
                    :src="`${ROOT}images/icons/arrowDown.png?${APP_VERSION_QS}`"
                    alt=""
                >

            </slot>
        </a>
        <SideNav v-if="props.sidenav" v-model="sideNavOpen" side="right" :title="props.sidenavTitle">
            <ul class="nav navbar-nav">
                <slot name="menu-before" />
                <MenuSingleItem v-for="xfm in panel0.panel" :key="xfm.path" :form="xfm" />
                <slot name="menu-after" />
            </ul>
        </SideNav>
        <div v-else :id="panel0.id" ref="collapsePanelRef" class="bg-info-content panel-collapse collapse in">
            <ul class="nav navbar-nav">
                <slot name="menu-before" />
                <template v-if="props.multilineLayout && chunks">
                    <ul v-for="(chunk, i) in chunks" :key="i" class="wrap_Menu-fatture">
                        <MenuSingleItem v-for="xfm in chunk" :key="xfm.path" :form="xfm" />
                    </ul>
                </template>
                <template v-else>
                    <MenuSingleItem v-for="xfm in panel0.panel" :key="xfm.path" :form="xfm" />
                </template>
                <slot name="menu-after" />
            </ul>
        </div>
    </li>
</template>
